import "./Label.css";

export interface LabelProps {}

const Label: React.FC<LabelProps> = (LabelProps) => {
  return <label>{LabelProps.children}</label>;
};

export default Label;
